import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStores } from 'src/models';

export const CInfoModal = observer(() => {
  const { alertStore } = useStores();
  const { open, title, onClick, content } = alertStore;
  const { t } = useTranslation();

  return (
    <StyledDialog fullWidth open={open}>
      <StyledDialogTitle>{title}</StyledDialogTitle>
      {content && <StyledDialogContent>{content}</StyledDialogContent>}
      <DialogActions>
        <StyledConfirmButton variant="contained" onClick={onClick}>
          {t('infoAlert.confirm')}
        </StyledConfirmButton>
      </DialogActions>
    </StyledDialog>
  );
});

export default CInfoModal;

const StyledDialog = styled(Dialog)(() => ({
  '.MuiPaper-root': {
    borderRadius: '16px',
  },
  maxWidth: '400px',
  margin: 'auto',
}));

const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '150%',
  textAlign: 'center',
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '150%',
  textAlign: 'center',
  color: theme.palette.grey[500],
}));

const StyledConfirmButton = styled(Button)(() => ({
  width: '100%',
  height: '50px',
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '150%',
  borderRadius: '8px',
}));
